<template>
  <div
    :class="[
      'min-h-screen w-screen flex flex-col items-center overflow-y-auto bg-gradient-to-br from-amber-50 via-orange-50/30 to-violet-100/25 px-4',
      compact
        ? 'justify-start pt-6 pb-6 sm:pt-8 sm:pb-8'
        : 'justify-center py-10',
    ]"
  >
    <div :class="['w-full', compact ? 'max-w-xl' : 'max-w-lg']">
      <div
        :class="[
          'rounded-2xl border border-stone-200/80 bg-white/95 shadow-xl shadow-stone-300/25 backdrop-blur-sm',
          compact ? 'p-5 sm:p-6' : 'p-8 sm:p-10',
        ]"
      >
        <header :class="['text-center', compact ? 'mb-4' : 'mb-8']">
          <div
            v-if="showLogo"
            :class="['flex justify-center', compact ? 'mb-3' : 'mb-5']"
          >
            <Image
              :src="logoSrc"
              alt="Symphony"
              :width="compact ? 112 : 128"
              :class="[
                'h-auto select-none opacity-[0.94]',
                compact
                  ? 'w-20 max-w-[5rem] sm:w-24 sm:max-w-[6rem]'
                  : 'w-28 max-w-[8rem] sm:w-32 sm:max-w-[9rem]',
              ]"
            />
          </div>
          <p
            v-else-if="eyebrow"
            class="mb-2 text-xs font-semibold uppercase tracking-wider text-amber-800/90"
          >
            {{ eyebrow }}
          </p>
          <h1
            :class="[
              'font-semibold leading-tight text-stone-900',
              compact ? 'text-xl sm:text-2xl' : 'text-2xl sm:text-3xl',
            ]"
          >
            {{ title }}
          </h1>
          <p
            :class="[
              'text-stone-600',
              compact ? 'mt-2 text-sm leading-snug' : 'mt-3 text-base leading-relaxed',
            ]"
          >
            {{ lead }}
          </p>
        </header>

        <div :class="compact ? 'space-y-2.5' : 'space-y-4'">
          <slot />
        </div>
      </div>

      <div
        v-if="slots.after"
        :class="['text-center text-sm text-stone-600', compact ? 'mt-4' : 'mt-8']"
      >
        <slot name="after" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useSlots } from 'vue';
import logoVertical from '@/assets/logos/Symphony_Logo_Vertical_RGB.png';

const slots = useSlots();

defineProps({
  /** Shown above the title only when showLogo is false */
  eyebrow: {
    type: String,
    default: 'Symphony',
  },
  title: {
    type: String,
    required: true,
  },
  lead: {
    type: String,
    required: true,
  },
  /** Brand mark in the header (replaces text eyebrow when true) */
  showLogo: {
    type: Boolean,
    default: true,
  },
  logoSrc: {
    type: String,
    default: () => logoVertical,
  },
  /** Tighter spacing and typography so dense forms (e.g. register) fit one viewport */
  compact: {
    type: Boolean,
    default: false,
  },
});
</script>
